// components/SalesBreakdown.jsx
import React from "react";
import { FiDollarSign } from "react-icons/fi";

const SalesBreakdown = ({ stats, formatCurrency }) => {
  const salesItems = [
    {
      label: "Daily Sales",
      amount: stats.dailySales,
      percentage:
        stats.monthlySales > 0
          ? (stats.dailySales / stats.monthlySales) * 100
          : 0,
      color: "bg-gray-900",
    },
    {
      label: "Weekly Sales",
      amount: stats.weeklySales,
      percentage:
        stats.monthlySales > 0
          ? (stats.weeklySales / stats.monthlySales) * 100
          : 0,
      color: "bg-gray-700",
    },
    {
      label: "Monthly Sales",
      amount: stats.monthlySales,
      percentage: 100,
      color: "bg-gray-500",
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-gray-900">Sales Breakdown</h3>
        <FiDollarSign size={24} className="text-gray-400" />
      </div>
      <div className="space-y-4">
        {salesItems.map((item, index) => (
          <div key={index} className={index > 0 ? "pt-2" : ""}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-gray-600">{item.label}</span>
              <span className="font-bold text-gray-900">
                {formatCurrency(item.amount)}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className={`${item.color} h-2 rounded-full`}
                style={{ width: `${item.percentage}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesBreakdown;
